// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customerSupportContainer {
  max-width: 800px;
  padding: 20px 0;
}

.pageTitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.pageDescription {
  color: #666;
  margin-bottom: 30px;
}

.contactInfoContainer {
  width: 100%;
}

.contactCard {
  background-color: #FFF5E9;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.contactTitle {
  font-size: 18px;
  color: #FF6B00;
  margin-bottom: 20px;
  font-weight: bold;
}

.contactInfo {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contactItem {
  display: flex;
  align-items: flex-start;
}

.contactLabel {
  width: 150px;
  font-weight: 600;
  color: #333;
  flex-shrink: 0;
  white-space: nowrap;
}

.contactValue {
  color: #555;
  flex: 1 1;
}

.supportActions {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.newRequestButton {
  background-color: #FF6B00;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.newRequestButton:hover {
  background-color: #E55F00;
}

.supportList {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.supportListHeader {
  display: flex;
  background-color: #f8f8f8;
  padding: 15px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
}

.supportListItem {
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.2s;
}

.supportListItem:hover {
  background-color: #f9f9f9;
}

.supportListItem:last-child {
  border-bottom: none;
}

.columnHeader, .column {
  padding: 0 10px;
}

.date {
  width: 20%;
}

.title {
  width: 60%;
}

.status {
  width: 20%;
  text-align: center;
}

.status.pending {
  color: #ff9800;
}

.status.completed {
  color: #4caf50;
}

.emptyMessage {
  text-align: center;
  padding: 40px;
  color: #999;
  font-style: italic;
}

/* 모바일 대응 */
@media (max-width: 768px) {
  .customerSupportContainer {
    padding: 15px;
  }
  
  .contactCard {
    padding: 20px;
  }
  
  .contactItem {
    flex-direction: column;
    gap: 5px;
  }
  
  .contactLabel {
    width: 100%;
  }
  
  .supportListHeader, .supportListItem {
    padding: 10px;
  }
  
  .date {
    width: 25%;
  }
  
  .title {
    width: 50%;
  }
  
  .status {
    width: 25%;
  }
} `, "",{"version":3,"sources":["webpack://./src/styles/CustomerSupport.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAO;AACT;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".customerSupportContainer {\n  max-width: 800px;\n  padding: 20px 0;\n}\n\n.pageTitle {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.pageDescription {\n  color: #666;\n  margin-bottom: 30px;\n}\n\n.contactInfoContainer {\n  width: 100%;\n}\n\n.contactCard {\n  background-color: #FFF5E9;\n  border-radius: 10px;\n  padding: 30px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.contactTitle {\n  font-size: 18px;\n  color: #FF6B00;\n  margin-bottom: 20px;\n  font-weight: bold;\n}\n\n.contactInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.contactItem {\n  display: flex;\n  align-items: flex-start;\n}\n\n.contactLabel {\n  width: 150px;\n  font-weight: 600;\n  color: #333;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.contactValue {\n  color: #555;\n  flex: 1;\n}\n\n.supportActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n}\n\n.newRequestButton {\n  background-color: #FF6B00;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  padding: 10px 20px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n}\n\n.newRequestButton:hover {\n  background-color: #E55F00;\n}\n\n.supportList {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.supportListHeader {\n  display: flex;\n  background-color: #f8f8f8;\n  padding: 15px;\n  font-weight: bold;\n  border-bottom: 1px solid #eee;\n}\n\n.supportListItem {\n  display: flex;\n  padding: 15px;\n  border-bottom: 1px solid #eee;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.supportListItem:hover {\n  background-color: #f9f9f9;\n}\n\n.supportListItem:last-child {\n  border-bottom: none;\n}\n\n.columnHeader, .column {\n  padding: 0 10px;\n}\n\n.date {\n  width: 20%;\n}\n\n.title {\n  width: 60%;\n}\n\n.status {\n  width: 20%;\n  text-align: center;\n}\n\n.status.pending {\n  color: #ff9800;\n}\n\n.status.completed {\n  color: #4caf50;\n}\n\n.emptyMessage {\n  text-align: center;\n  padding: 40px;\n  color: #999;\n  font-style: italic;\n}\n\n/* 모바일 대응 */\n@media (max-width: 768px) {\n  .customerSupportContainer {\n    padding: 15px;\n  }\n  \n  .contactCard {\n    padding: 20px;\n  }\n  \n  .contactItem {\n    flex-direction: column;\n    gap: 5px;\n  }\n  \n  .contactLabel {\n    width: 100%;\n  }\n  \n  .supportListHeader, .supportListItem {\n    padding: 10px;\n  }\n  \n  .date {\n    width: 25%;\n  }\n  \n  .title {\n    width: 50%;\n  }\n  \n  .status {\n    width: 25%;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
